/**
 * Used internally to determine how much data to be gather from input buffer at each key frame.
 * @param accessorType the accessor type
 * @returns the number of item to be gather at each keyframe
 */
export function getDataAccessorElementCount(accessorType) {
    switch (accessorType) {
        case "SCALAR" /* SCALAR */:
            return 1;
        case "VEC2" /* VEC2 */:
            return 2;
        case "VEC3" /* VEC3 */:
            return 3;
        case "VEC4" /* VEC4 */:
        case "MAT2" /* MAT2 */:
            return 4;
        case "MAT3" /* MAT3 */:
            return 9;
        case "MAT4" /* MAT4 */:
            return 16;
    }
}
//# sourceMappingURL=glTFUtilities.js.map